import React from 'react';
import styled from 'styled-components';
import logo from "../../logo.png";

const Footer = styled.footer`
    margin-top: 40px;
    padding: 26px 20px;
    background: #111;
    color: #eee;
    text-align: center;

    img {
        height: 36px;
        display: block;
        margin: 0 auto 10px;
    }
`;

export default function FooterSection() {

    return (
        <Footer>
            <img src={logo} alt="EPDM Trading Bulgaria – лого"/>
            <div>© {new Date().getFullYear()} EPDM Trading Bulgaria — Всички права запазени.</div>
            <div style={{opacity: .85, marginTop: 6}}>T: +359 888 751 443 • E: office@epdm.bg</div>
        </Footer>
    );
}
